const state = {
  enterPageLoading: false,
};

// Getter functions
const getters = {};

// Mutations
const mutations = {
  setEnterPageLoading(state, loading) {
    state.enterPageLoading = loading;
  },
};

// Actions
const actions = {
  enterPage({ commit }) {
    commit('setEnterPageLoading', true);
  },
  pageLoaded({ commit }) {
    commit('setEnterPageLoading', false);
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
